/**
 * `/` — redirect to /read/{lastPage}, resuming where the reader left off (§6).
 */
import { createFileRoute, redirect } from '@tanstack/react-router'
import { LS_LAST_PAGE, clampPage } from '@mushaf/corpus'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    let page = 1
    try {
      const raw = localStorage.getItem(LS_LAST_PAGE)
      const parsed = Number(raw)
      // Validate 1..604; fall back to 1. A corrupt value must not strand the reader.
      if (Number.isFinite(parsed) && parsed >= 1 && parsed <= 604) page = clampPage(parsed)
    } catch {
      page = 1
    }
    throw redirect({ to: '/read/$page', params: { page: String(page) } })
  },
})
